import * as React from 'react';
import { observer } from 'mobx-react';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { NavigationStore } from 'nomst/Stores/Navigation/navigation.store';
import { managerIdParameterName } from 'nomst/Stores/Navigation/Constants/decisionPageUrl';
import { Org } from '@payscale/payscale-employee-service/lib/';
import { dataManagerFactory } from 'utils/MobxDataManager/singletons';
import { ReportsView } from 'typings/enums';
import * as formatParse from 'common/format-parse';

export interface IOrgChartProps {
    url: string;
    navigationStore: NavigationStore;
    configuration: Configuration;
}

export class OrgChart extends React.Component<IOrgChartProps> {
    managerSourceIds: string[];

    constructor(props: IOrgChartProps) {
        super(props);
        this.handleOnClose = this.handleOnClose.bind(this);
        this.onViewEmployee = this.onViewEmployee.bind(this);
    }

    render(): React.ReactNode {
        const queryParameters = formatParse.getJsonFromUrl(this.props.url);
        this.managerSourceIds = queryParameters[managerIdParameterName];
        if (!this.managerSourceIds || this.managerSourceIds.length === 0) {
            return null;
        }

        const employeeSourceId = this.managerSourceIds[0];
        const employeeDataManager = dataManagerFactory.getEmployeeDataManager();

        const { configuration } = this.props;
        return (
            <div className="org-chart">
                <Org
                    baseUrl={employeeDataManager.baseUrl}
                    accessToken={configuration.accessToken}
                    masterAccountId={configuration.masterAccountId}
                    onClose={this.handleOnClose}
                    onViewEmployee={this.onViewEmployee}
                    employeeSourceId={employeeSourceId}
                    displayedLevelCount={4}
                    maxRowsPerLevel={5}
                    employeeSortFormat={configuration.employeeNameSortFormat}
                    isHidden={false}
                    closeLinkText={'Return to Team View'}
                />
            </div>
        );
    }

    private handleOnClose(): void {
        const { navigationStore, configuration } = this.props;
        navigationStore.navigateToWorkflowStatusManagersRoute(
            configuration.cycleId,
            this.managerSourceIds,
            null,
            ReportsView.DirectsOnly);
    }

    private onViewEmployee(employeeSourceId: string): void {
        if (!employeeSourceId) {
            return;
        }
        const { navigationStore, configuration } = this.props;
        navigationStore.navigateToWorkflowStatusManagersRoute(
            configuration.cycleId,
            [employeeSourceId],
            null,
            ReportsView.DirectsOnly,
            false);
    }
}

export default observer(OrgChart);